import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { blogslisting } from '../services/authService';
import { useNavigate } from 'react-router-dom';
import { linkapi } from '../services/authService';
import { FaExternalLinkAlt } from 'react-icons/fa';
const Dashboard = () => {
  const [selectedOption, setSelectedOption] = useState('');
  const [isLoading, setIsLoading] = useState(false);  
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [apiData, setApiData] = useState([]);
  const isReadOnly = false;
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('authToken');

    if (!isAuthenticated) {
      navigate('/');
    }
    const savedOption = sessionStorage.getItem('selectedOption');
    const savedData = sessionStorage.getItem('apiData');
    if (savedOption) {
      setSelectedOption(savedOption);
    }
    if (savedData) {
      try {
        setApiData(JSON.parse(savedData));
      } catch (error) {
        console.error('Error parsing saved data:', error);
      }
    }
  }, [navigate]);


  const handleAddNew = () => {
    navigate('/blogfield', { state: { selectedOption, apiData } });
  };

  const handleLogout = () => {
    // Handle logout logic here (e.g., clearing auth tokens)
    const isAuthenticated = localStorage.getItem('authToken');
    console.log("is", isAuthenticated)
    localStorage.removeItem('authToken');

    navigate("/");
  };

  const handleEdit = async (postId) => {
    localStorage.setItem("updatedetails", JSON.stringify(postId))
    setIsActionLoading(true);
    try {
      const result = await linkapi(postId.BlogURL); // Await the API result
      const parser = new DOMParser();
      const doc = parser.parseFromString(result.data, "text/html");
      const preTag = doc.querySelector("pre");

      if (preTag) {
        const jsonString = preTag.textContent;
        localStorage.setItem("blogdetails", jsonString)
      }
    } catch (error) {
      console.error("Error while fetching API:", error);

    } finally {
      setIsActionLoading(false);
      navigate('/edit/blogfield', { state: { postId} });
    }
  };

  const handleOptionChange = async (event) => {
    const selectedValue = event.target.value;
    const body = {
      "filters": {
        // "website": //["gmart.in","network.gmart.in", "automation.gmart.in"]
        "website": "devices.encriss.com"
      },
      "nextPaginationKey": ""
    }
    setSelectedOption(selectedValue);
    sessionStorage.setItem('selectedOption', selectedValue); // Persist selected option
    setIsLoading(true);
    if (selectedValue) {

      try {
        const response = await blogslisting(selectedValue);
        const filtered = response.data
          .filter((user) => user.website === selectedValue)
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setApiData(filtered);
        sessionStorage.setItem('apiData', JSON.stringify(filtered));
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error('Error fetching data:', error);
      }
    } else {
      setApiData([]);
      sessionStorage.removeItem('apiData'); // Clear session data if no option selected
    }
  };
  const tableOverlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255,255,255,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 5,
  };

  return (
    <div>
      {/* Header */}
      <header
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px 20px',
          backgroundColor: '#f8f9fa',
          borderBottom: '1px solid #ddd',
          marginBottom: '20px',
        }}
      >
        <Form.Group controlId="status" style={{ marginBottom: 0 }}>
          <Form.Label>Website URL</Form.Label>
          <Form.Select
            defaultValue=""
            onChange={handleOptionChange}
            value={selectedOption}
            disabled={isReadOnly}
            required
            style={{
              width: '250px',
              height: '38px',
              fontSize: '14px',
            }}
          >
            <option value="">Select Website URL</option>
            {['gmart.in', 'encriss.com', 'automation.gmart.in', 'network.gmart.in', 'devices.encriss.com', 'testing.in', 'emprise.gmart.in', 'admin.gmart.in'].map((status, index) => (
              <option key={index} value={status}>
                {status}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <div>
          <Button
            variant="success"
            style={{ marginRight: '10px' }}
            onClick={() => navigate('/admin')}
          >
            Admin Panel
          </Button>
          <Button variant="success" onClick={handleAddNew} style={{ marginRight: '10px' }}>
            Add New
          </Button>
          <Button variant="danger" onClick={handleLogout}>
            Logout
          </Button>
        </div>
      </header>

      {/* Table to display fetched data */}
            <div style={{ position: 'relative' }}>
        {isLoading && (
          <div style={tableOverlayStyle} aria-hidden="true">
            <Spinner animation="border" role="status" />
          </div>
        )}
      <Table
        striped
        bordered
        hover
        size="sm"
        style={{
          width: '100%',
          margin: '20px 0',
          borderCollapse: 'collapse',
        }}
      >
        <thead>
          <tr>
            <th style={{
              backgroundColor: "#f2f2f2",
              color: "#333",
              fontWeight: "bold",
              padding: "12px",
              textAlign: "left",
              border: "1px solid #ddd",
            }}>URL Name</th>
            <th style={{
              backgroundColor: "#f2f2f2",
              color: "#333",
              fontWeight: "bold",
              padding: "12px",
              textAlign: "left",
              border: "1px solid #ddd",
            }}>Title</th>
            <th style={{
              backgroundColor: "#f2f2f2",
              color: "#333",
              fontWeight: "bold",
              padding: "12px",
              textAlign: "left",
              border: "1px solid #ddd",
            }}>Cover Image</th>
            <th style={{
              backgroundColor: "#f2f2f2",
              color: "#333",
              fontWeight: "bold",
              padding: "12px",
              textAlign: "left",
              border: "1px solid #ddd",
            }}>Current Status</th>
            <th style={{
              backgroundColor: "#f2f2f2",
              color: "#333",
              fontWeight: "bold",
              padding: "12px",
              textAlign: "left",
              border: "1px solid #ddd",
            }}>Blog Category</th>
            <th style={{
              backgroundColor: "#f2f2f2",
              color: "#333",
              fontWeight: "bold",
              padding: "12px",
              textAlign: "left",
              border: "1px solid #ddd",
            }}>Created At</th>
            <th style={{
              backgroundColor: "#f2f2f2",
              color: "#333",
              fontWeight: "bold",
              padding: "12px",
              textAlign: "left",
              border: "1px solid #ddd",
            }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {apiData.length > 0 ? (
            apiData.map((post, index) => (
              <tr key={index}>
                <td style={{ paddingLeft: "15px" }}>{post.website}</td>
                <td>
                  <a href={post.BlogURL} target="_blank" rel="noopener noreferrer">
                    {post.BlogTitle} <FaExternalLinkAlt style={{ marginLeft: '5px' }} />
                  </a>
                </td>
                <td>
                  <img src={post.coverImage} alt={post.title} width="100" />
                </td>
                <td>{post.PublishingStatus}</td>
                <td>{post.BlogCategory}</td>
                <td>{new Date(post.created_at).toLocaleDateString("en-GB")}</td>
                <td>
                  <Button variant="primary" onClick={() => handleEdit(post)}>
                    Edit
                  </Button>
                  {post.PublishingStatus === "published" ? (
                    <Button variant="warning">Unpublish</Button>
                  ) : (
                    <Button variant="success">Publish</Button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" style={{ textAlign: 'center' }}>
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      </div>
    </div>
  );
};

export default Dashboard;
